import { render, staticRenderFns } from "./DesgloseZonasTable.vue?vue&type=template&id=36878dbd"
import script from "./DesgloseZonasTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DesgloseZonasTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports